import { render, staticRenderFns } from "./DedicationCommunicationView.vue?vue&type=template&id=45b00a2e&"
import script from "./DedicationCommunicationView.vue?vue&type=script&lang=js&"
export * from "./DedicationCommunicationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports